import { FC } from "react";
import { useMediaQuery } from "react-responsive";

import { findBrandByDomain } from "../../../configs/configLoader";
import { font, welcomeScreenUI } from "../../../configs";
import { isPhysicalAndroidDevice } from "../../../utils";

import "./index.css";

interface IPropsMeasuredBy {
  step: any;
}

const MeasuredBy: FC<IPropsMeasuredBy> = ({ step }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const brandDefined = findBrandByDomain();

  const isMobileSRP = isMobile && brandDefined?.name === "SRP";
  const isAndroid = isPhysicalAndroidDevice();

  return (
    <div>
      <div
        className="measured-by"
        style={{
          position:
            isMobileSRP || (!isMobile && !isMobileSRP) ? "fixed" : "relative",
          bottom: isMobileSRP || (!isMobile && !isMobileSRP) ? "10px" : "0",
          top: isMobileSRP || (!isMobile && !isMobileSRP) ? "inherit" : "10px",
          color:
            brandDefined?.name === "KENZO"
              ? welcomeScreenUI.genderCTA.focused.backgroundColor
              : brandDefined?.name === "SRP"
              ? "#767474"
              : "#000000B2",
          fontSize:
            brandDefined?.name === "SRP"
              ? "12px"
              : welcomeScreenUI.genderCTA.unfocused.fontSize,
        }}
      >
        Measured by{" "}
        <span
          style={{
            color:
              brandDefined?.name === "KENZO"
                ? welcomeScreenUI.genderCTA.focused.backgroundColor
                : "#000000",
            fontSize:
              brandDefined?.name === "SRP"
                ? "12px"
                : welcomeScreenUI.genderCTA.unfocused.fontSize,
            position: "relative",
            top: isAndroid && font === "Futura" ? "3px" : 0,
          }}
        >
          kleep
        </span>{" "}
      </div>
    </div>
  );
};

export default MeasuredBy;
